import { createContext, useContext, useEffect, useState } from "react";

export const AuthContext = createContext(null);

export const AuthProvider = ({children}) =>{

    //const [token, setToken] = useState(localStorage.getItem("cpmstoken") || null);
    const [token, setToken] = useState(sessionStorage.getItem("cpmstoken") || null);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("userinfo")) || null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        if (token) 
        {
            //localStorage.setItem("cpmstoken", token);
            sessionStorage.setItem("cpmstoken", token);
        } 
        else 
        {
            //localStorage.removeItem("cpmstoken");
            sessionStorage.removeItem("cpmstoken");
        }

        setLoading(false);

    }, [token]);

    useEffect(() => {

        if (user) 
        {
            localStorage.setItem("userinfo", JSON.stringify(user));
        } 
        else 
        {
            localStorage.removeItem("userinfo");
        }

        setLoading(false);

    }, [user]);

    return(
    
    <AuthContext.Provider value={{ user, setUser, loading, token, setToken }}>
        {children}
    </AuthContext.Provider>

    );

}

export const useAuth = () => {
    return useContext(AuthContext);
};